import React from "react";
import { string, oneOf } from "prop-types";

import Icon from "../Icon/Icon.jsx";

const propTypes = {
  href: string.isRequired,
  type: oneOf(["", "external", "download", "anchor", "jump"]),
  text: string,
  title: string,
  className: string,
};

const ArrowLink = (props) => {
  const { href, type, text, title, className } = props;

  const classModifier = type ? `arrow-link--${type}` : "";

  return (
    <a
      href={href}
      aria-label={title}
      className={`arrow-link ${classModifier} ${className}`}
    >
      <span>{text}</span>
      <Icon iconName="arrow-right" />
    </a>
  );
};
ArrowLink.propTypes = propTypes;
export default ArrowLink;
